export default __webpack_public_path__ + "static/media/filiar_templo.0273327c.mp4";